var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-container',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"alt":"Vue logo","src":"/img/logo.png"}}),_c('h1',[_vm._v("加班研发中，请耐心等待！！！")])])
}
var staticRenderFns = []

export { render, staticRenderFns }